import React from 'react'
import CustomCursor from '../../Global/Cursor';
import Preloader from '../../Global/Preloader'
import Header from '../../Global/Header1';
import PageInear from '../MenBlogDetails/PageInear';
import Details from '../MenBlogDetails/Details';
import Cta from '../../Global/Cta';
import Footer_1 from '../../Global/Footer1';
import GoToTop from '../../Global/GoToTop';

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageInear />
            <Details />
            <Cta />
            <Footer_1 />
            <GoToTop />

        </>
    )
}

export default Main
